<button
  class="notification-item"
  [class.notification-item--read]="item().read"
  [class.notification-item--unread]="!item().read"
  type="button"
  (click)="onOpen()"
>
  <span class="notification-item__status" aria-hidden="true"></span>
  <span class="notification-item__body">
    <span class="notification-item__title">{{ item().title }}</span>
    <span class="notification-item__message">{{ item().message }}</span>
    <span class="notification-item__time">{{ formatCreatedAt(item().createdAt) }}</span>
  </span>
</button>

